import { createPortal } from 'react-dom';
import CloseButtonSVG from '@Assets/close-button.svg?react';
import WithWatermark from '../WithWatermark';
import './styles.scss';

export const WatermarkedMediaOverlay = ({
  open,
  onClose,
  watermark,
  targetElementId,
  children,
}: {
  open: boolean;
  onClose: () => void;
  watermark: string;
  targetElementId: string;
  children: React.ReactNode;
}) => {
  if (!open) {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 z-20 bg-black/80" onClick={onClose} />
      <div className="absolute inset-0 z-30 mx-auto flex w-[80vw] max-w-[80vw] items-center justify-center overflow-hidden">
        <CloseButtonSVG
          className="absolute left-6 top-6 z-40 h-6 w-6 cursor-pointer fill-white"
          onClick={onClose}
        />
        <div className="video-no-fullscreen h-full w-full">
          <WithWatermark content={watermark} targetElementId={targetElementId}>
            <div
              id={targetElementId}
              className="flex h-full w-full items-center justify-center"
            >
              {children}
            </div>
          </WithWatermark>
        </div>
      </div>
    </div>,
    document.body,
  );
};
